import { collection, doc } from "firebase/firestore";
import { db } from "./init-firebase";

export const chargerCollectionRef = collection(db, "ChargersList");
export const chargersCollectFilter = collection(db, "Chargers");
export const chargersFilter = doc(db, "Chargers/ABB Terra AC display, cable, 3P, 32A, RFID, 4G, MID/Portfolio analysis/Company Name");
// export const chargersDocumentTestRef = doc(db, "chargers");